import AcUnitIcon from '@mui/icons-material/AcUnit';
import WifiIcon from '@mui/icons-material/Wifi';
import OpacityIcon from '@mui/icons-material/Opacity';
import LocalParkingIcon from '@mui/icons-material/LocalParking';
import AddIcon from '@mui/icons-material/Add';
import WeekendIcon from '@mui/icons-material/Weekend';
import ChairIcon from '@mui/icons-material/Chair';
import AirIcon from '@mui/icons-material/Air';
import WcIcon from '@mui/icons-material/Wc';
import LocalCafeIcon from '@mui/icons-material/LocalCafe';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import InventoryIcon from '@mui/icons-material/Inventory';
import KitchenIcon from '@mui/icons-material/Kitchen';
import i18n from './i18n';
import { useTranslation } from 'react-i18next';
  
// Amenity labels & icons
// This function can be used outside of React components by importing i18n directly
export const getAmenityLabel = (key: string): string => {
  if (!key) return '';
  return (i18n.t as any)(`amenities.${key}`, key);
};

// For React components, use this hook-based version which will update when language changes
export const useAmenityLabel = () => {
  const { t } = useTranslation();
  return (key: string) => {
    if (!key) return '';
    return (t as any)(`amenities.${key}`, key);
  };
};

export const amenityIcons: Record<string, JSX.Element> = {
  AIR_CONDITIONING: <AcUnitIcon fontSize="small" />,
  WIFI:             <WifiIcon fontSize="small" />,
  WATER_COOLER:     <OpacityIcon fontSize="small" />,
  PARKING:          <LocalParkingIcon fontSize="small" />,
  SOFA:             <WeekendIcon fontSize="small" />,
  CHAIR:            <ChairIcon fontSize="small" />,
  FAN:              <AirIcon fontSize="small" />,
  WC:               <WcIcon fontSize="small" />,
  COFFEE_TEA:       <LocalCafeIcon fontSize="small" />,
  WATER:            <WaterDropIcon fontSize="small" />,
  EQUIPMENT_STORAGE: <InventoryIcon fontSize="small" />,
  FRIDGE:           <KitchenIcon fontSize="small" />,
  CUSTOM:           <AddIcon fontSize="small" />,
};
